import React, { FC } from 'react'

import { TextLinkProps } from '../A'

import * as SC from './styled'

export type TagProps = TextLinkProps & {
  className?: string
  textColor?: string
  backgroundColor?: string
}

const Tag: FC<TagProps> = (props) => {
  const { className, textColor, backgroundColor, ...tag } = props

  return (
    <SC.Container className={className}>
      <SC.Tag
        $textColor={textColor}
        $backgroundColor={backgroundColor}
        {...tag}
      >
        <SC.TagText>
          {tag?.text.charAt(0).toUpperCase() + tag?.text.slice(1)}
        </SC.TagText>
      </SC.Tag>
    </SC.Container>
  )
}

export default Tag
